/* import __COLOCATED_TEMPLATE__ from './sh-payments-record-list-item.hbs'; */
import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { SH_PAYMENT } from "../../../../models/sh-payment";
import { showModal } from "sh-www/utils/modal-controls";

/**
 * This is an individual record item for the sh-invoice list view in admin
 */
export default Component.extend({
  /**
   * @inheritDoc
   */
  tagName: 'li',
  classNames: ['SH-c-payments-record-list-item', 'LSG-l-grid', 'justify-between', 'padding-top-bottom-16px', 'border-top-lsg-black'],
  classNameBindings: [
    '_isOddIndex:background-lsg-xlight-gray',
    '_isOddIndex::background-lsg-white'
  ],

  /**
   * Register services
   */
  constants: service(),
  state: service('states/routes/admin/accounting/payout'),
  stateManager: service('state-managers/routes/admin/accounting/payout'),

  /*********************************
   * REQUIRED PARAMS
   *********************************/

  /**
   * @param {Number}
   */
  indexInTable: 0,

  /**
   * @param {ShPayment}
   */
  shPayment: null,

  /*********************************
   * OPTIONAL PARAMS
   **********************************/

  /*********************************
   * LIFECYCLE FUNCTIONS
   **********************************/

  /*********************************
   * PRIVATE
   **********************************/

  /**
   * @type {User|null}
   */
  _userEntity: computed('shPayment.user.id', function() {
    return this.get('shPayment.user');
  }),

  /**
   * @type {String}     The css class for the payment status
   */
  _paymentStatusTextClass: computed('shPayment.paymentStatusText', function() {
    let statusTextClass = 'font-weight-700 ';

    switch (this.get('shPayment.paymentStatusText')) {
      case SH_PAYMENT.STATUS.PAID:
        return statusTextClass += 'lsg-green';
      case SH_PAYMENT.STATUS.ERROR:
        return statusTextClass += 'lsg-red';
      case SH_PAYMENT.STATUS.DUE:
        return statusTextClass += 'lsg-yellow';
    }

    return statusTextClass += 'lsg-dark-gray';
  }),

  /**
   * @type {Number}
   */
  _paymentTotalAmount: computed('shPayment.shPaymentLineItems.@each.amount', function() {
    return this.get('shPayment.shPaymentLineItems').reduce((carry, shPaymentLineItem) => {
      return carry + shPaymentLineItem.get('amount');
    }, 0);
  }),

  /**
   * @type {Boolean}
   */
  _isOddIndex: computed('indexInTable', function() {
    return this.get('indexInTable') % 2 === 1;
  }),

  /** @type {String} The payment method(s) as a formatted string. */
  _payoutMethods: computed(
    'shPayment.shPaymentTransactions.@each.processor',
    'shPayment.user.preferredPayoutAccount.accountType',
    function () {
      const transactions = this.get('shPayment.shPaymentTransactions');

      if (!transactions || !transactions.get('length')) {
        return this.get('shPayment.user.preferredPayoutAccount.accountType');
      }

      return transactions.mapBy('processor').uniq().join(', ');
    }
  ),

  actions: {
    /**
     * @param {ShPayment} shPayment
     */
    onEditPaymentClicked(shPayment) {
      let transactions = shPayment.get('shPaymentTransactions');

      let modalModel = {
        shPayment: shPayment,
        shPaymentTransaction: transactions.get('length') ? transactions.objectAt(0) : null,
        onTransactionEdited: (shPaymentTransaction) => {
          this.get('stateManager').handlePaymentTransactionSaved(shPayment, shPaymentTransaction);
        }
      };

      showModal(this, 'admin/edit-sh-payment-transaction-modal', modalModel);
    }
  }
});
